import * as React from 'react';
import { connect } from 'react-redux';

import BrandEditProfile from '../../brands/components/BrandEditProfile';

import BaseAgencyPage from './BaseAgencyPage';

import { t } from 'utils/language';

import type { Params } from 'types';

type StateProps = {
  isAdminMode: boolean
};

type OwnProps = {
  params: Params
};

type Props = OwnProps & StateProps;

const AgencyEditProfilePage = ({
  params,
  isAdminMode
}: Props) => (
  <BaseAgencyPage
    id={Number(params.id)}
    documentTitle={t('agency_edit_profile_page_title')}
    renderChildren={(agencyBrandProfileId) => (
      <BrandEditProfile
        key={agencyBrandProfileId}
        profileId={agencyBrandProfileId}
        agencyId={Number(params.id)}
        organizationType="agency"
        isSpecialtyAdminPage={isAdminMode}
      />
    )}
  />
);

const mapStateToProps = ({ router }): StateProps => ({
  isAdminMode: /^\/admin\//.test(router.location.pathname)
});

export default connect(mapStateToProps)(AgencyEditProfilePage);
